import { useEffect } from 'react';
import { resolvePlayerTheme } from 'magical-trails';

/**
 * Dresses the document in a story's look for as long as that story is open.
 *
 * Set on <html> (not on .Trail) because the pages render in a portal outside
 * that tree; the shared stylesheet's `--mt-*` tokens key off the attribute.
 * Removed on unmount so the start screen and the next trail begin from the
 * classic look.
 *
 * Takes the raw stored value (story settings → `playerTheme`) rather than a
 * resolved one, so a missing or unrecognised theme falls back to classic here
 * instead of at every call site.
 */
export function usePlayerTheme(theme: unknown): void {
  const resolved = resolvePlayerTheme(theme);

  useEffect(() => {
    document.documentElement.setAttribute('data-mt-theme', resolved);
    return () => {
      document.documentElement.removeAttribute('data-mt-theme');
    };
  }, [resolved]);
}

export default usePlayerTheme;
